import { DEFAULT_APPROVABLE_DURATION } from "@p0security/shared/configuration/constant";

import { DurationSetting } from "./DurationSetting.tsx";

export const MaxApprovalDuration: React.FC = () => (
  <DurationSetting
    description="Set the duration within which requests must be approved. Stale requests are automatically denied."
    field="approvableDuration"
    fallback={DEFAULT_APPROVABLE_DURATION}
    label="Approvable duration"
    route="settings/approvable-duration"
  />
);
